import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import DashBoard from '../../../components/DashBoard/DashBoard';
import JockeysCard from '../../../components/JockeysCard/JockeysCard';
import { useJockeys } from '../../../hooks/stable';
import useUpdateFilterParams from '../../../hooks/useUpdateFilterParams';
import JockeyFilters from '../JockeyFilters/JockeyFilters';
import styles from '../RaceStableList.module.scss';
const JockeyList = ({ filters }) => {
    useUpdateFilterParams();
    useJockeys();
    return (_jsx(DashBoard, Object.assign({ className: styles.raceView }, { children: _jsxs("div", Object.assign({ className: cn('d-flex') }, { children: [_jsx(JockeyFilters, { jockeyList: true, filter: filters }), _jsx("div", Object.assign({ className: styles.cardsBox }, { children: _jsx(JockeysCard, {}) }))] })) })));
};
export default JockeyList;
